import React from "react";
import { Helmet } from "react-helmet";

const TamilNaduSEO = () => {
  return (
    <Helmet>
      {/* 🟢 BASIC META */}
      <title>
        Buy Sex Toys in Tamil Nadu | Discreet Delivery in Chennai, Coimbatore
      </title>

      <meta
        name="description"
        content="Buy sex toys online in Tamil Nadu with 100% discreet delivery. Trusted adult store delivering to Chennai, Coimbatore, Madurai, Trichy & Salem. Products for men, women & couples."
      />

      <meta
        name="keywords"
        content="sex toys in Tamil Nadu, buy sex toys Chennai, sex toys Coimbatore, adult toys Madurai, sex toys Trichy, adult store Tamil Nadu, sex toys for men women couples"
      />

      <meta name="robots" content="index, follow" />

      {/* 🟢 CANONICAL */}
      <link
        rel="canonical"
        href="https://lushdesire.in/sex-toys-delivery/tamil-nadu"
      />

      {/* 🟢 OPEN GRAPH */}
      <meta property="og:type" content="website" />
      <meta
        property="og:title"
        content="Buy Sex Toys in Tamil Nadu | 100% Discreet Delivery"
      />
      <meta
        property="og:description"
        content="Order premium sex toys in Tamil Nadu with fast & private delivery. Serving Chennai, Coimbatore, Madurai & more."
      />
      <meta
        property="og:url"
        content="https://lushdesire.in/sex-toys-delivery/tamil-nadu"
      />
      <meta
        property="og:image"
        content="https://lushdesire.in/assets/og-tamil-nadu.jpg"
      />

      {/* 🟢 TWITTER */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:title"
        content="Sex Toys Delivery in Tamil Nadu | LushDesire"
      />
      <meta
        name="twitter:description"
        content="Discreet sex toys delivery across Tamil Nadu. Buy toys for men, women & couples online."
      />

      {/* 🟢 LOCAL SEO */}
      <meta name="geo.region" content="IN-TN" />
      <meta name="geo.placename" content="Tamil Nadu" />
      <meta name="geo.position" content="11.1271;78.6569" />
      <meta name="ICBM" content="11.1271, 78.6569" />

      {/* 🟢 SCHEMA */}
      <script type="application/ld+json">
        {`
        {
          "@context": "https://schema.org",
          "@type": "Store",
          "name": "LushDesire Tamil Nadu",
          "url": "https://lushdesire.in/sex-toys-delivery/tamil-nadu",
          "logo": "https://lushdesire.in/logo.png",
          "description": "Buy sex toys online in Tamil Nadu with discreet packaging. Trusted adult store delivering across Tamil Nadu.",
          "areaServed": {
            "@type": "State",
            "name": "Tamil Nadu"
          },
          "address": {
            "@type": "PostalAddress",
            "addressRegion": "Tamil Nadu",
            "addressCountry": "IN"
          }
        }
        `}
      </script>
    </Helmet>
  );
};

export default TamilNaduSEO;
